export default {
  nextJob: 'Następna praca',
  plannedJobMetricsUnavailable: 'Metryki będą dostępne po rozpoczęciu tego zadania.',
  previousJob: 'Poprzednia praca',
  detailsTabs: {
    events: 'Zdarzenia',
    images: 'Obrazy',
  },
};
